import { render, staticRenderFns } from "./PermissionsUserModal.vue?vue&type=template&id=19b21732&"
import script from "./PermissionsUserModal.vue?vue&type=script&lang=js&"
export * from "./PermissionsUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports